import { useEffect, useContext } from "react"
import { getFieldConfig } from "../config/fieldConfigs"
import { useFormikContext } from "formik"
import DynamicFormField from "./DynamicFormField"

const GenericAssetForm = ({
  subCategory,
  values,
  setFieldValue,
  errors,
  touched,
  defaultCurrency,
  readOnly = false,
  readOnlyFields = [],
  mode = "add"
}) => {
  const { setFieldTouched } = useFormikContext() || {}
  const config = getFieldConfig(subCategory)

  // Handle default currency setting (same as original)
  useEffect(() => {
    if ((!values.purchaseCurrency || values.purchaseCurrency === "") && defaultCurrency) {
      setFieldValue("purchaseCurrency", defaultCurrency)
    }
  }, [values.purchaseCurrency, defaultCurrency, setFieldValue])

  if (!config || (config.commonFields.length === 0 && config.specificFields.length === 0)) {
    return <div>No form configuration found for {subCategory}</div>
  }

  // Render all fields (commonFields + specificFields) from config
  // Filter out fields marked hideInAdd when in add mode
  const allFields = [...(config.commonFields || []), ...(config.specificFields || [])]
    .filter(field => !(mode === "add" && field.hideInAdd))

  return (
    <div className="row">
      {allFields.map((field) => {
        const isFieldReadOnly = readOnlyFields.includes(field.name)
        return (
          <DynamicFormField
            key={field.name}
            field={field}
            values={values}
            setFieldValue={setFieldValue}
            setFieldTouched={setFieldTouched}
            errors={errors}
            touched={touched}
            readOnly={readOnly || isFieldReadOnly}
          />
        )
      })}
    </div>
  )
}

export default GenericAssetForm
